import React, { PureComponent } from 'react';
import { Map, List, fromJS } from 'immutable';
import { injectIntl, defineMessages } from 'react-intl';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as common from 'libs/commonFunc';

import * as examActions from 'modules/exam';

import { CtExamHeader } from 'containers';
import { ExamLeakPCList } from 'components';

let SEARCH_VALUE = '';
class CtExamLeakPC extends PureComponent {
  constructor(props) {
    super(props);

    // 검색 기록 유지
    const { paramData } = this.props;
    const filterData = paramData.get('filter').toJS();
    let searchTypeData = 'searchAll';
    let searchTextData = '';
    if (Object.keys(filterData).length) {
      const searchOptions = [
        'searchAll',
        'infectionNo',
        'hostname',
        'ip',
        'targetName',
        'targetEmail',
        'examNo',
        'examName'
      ];
      searchOptions.map(option => {
        if (filterData[option]) {
          searchTypeData = option;
          searchTextData = filterData[option];
        }
      });
    }

    this.state = {
      loading: false,
      fromNowRegDate: false,
      fitRowCount: 0,
      currentPage: 0,
      pageSize: 0,
      searchType: searchTypeData,
      searchText: searchTextData
    };
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    this.setState({ pageSize: fitRowCount, fitRowCount });
    this.handleInitFilter();
  }

  componentDidUpdate(prevProps) {
    const { needReload, selectedExamSummaryNo, paramData } = this.props;

    if (
      // 선택한 훈련이 변경되었을 때
      selectedExamSummaryNo !== prevProps.selectedExamSummaryNo
    ) {
      this.setState({ currentPage: 0 });
    }

    if (
      (needReload && !this.state.loading) ||
      // 선택한 훈련이 변경되었을 때
      selectedExamSummaryNo !== prevProps.selectedExamSummaryNo ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData
    ) {
      this.getInfectionPC();
    }
  }

  getInfectionPC = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { currentPage, pageSize } = this.state;
        const { ExamActions, selectedExamSummaryNo, paramData } = this.props;
        const params = {
          filter: JSON.stringify(paramData.get('filter')),
          sort: JSON.stringify(paramData.get('sort')),
          offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          limit: pageSize < 1 ? 20 : pageSize
        };
        params.examNo = selectedExamSummaryNo;

        if (params.examNo === 'all') {
          params.examNo = undefined;
        }

        await ExamActions.getInfectionPCList(params);
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  // 필터 처리
  handleFetchData = ({ ...rest }) => {
    const { sorted } = rest;
    const sort = [];
    if (sorted && Array.isArray(sorted)) {
      // 정렬이 적용됨
      for (let i = 0; i < sorted.length; i++) {
        const data = sorted[i];
        sort.push({ field: data.id, order: data.desc ? 'DESC' : 'ASC' });
      }
    }

    const { ExamActions } = this.props;
    ExamActions.changeInfectionPCListParam({
      name: 'sort',
      value: fromJS(sort)
    });
  };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색
  handleOnSearch = e => {
    if (
      e.key === 'Enter' ||
      e.target.id === 'bt-search-input' ||
      e.target.parentNode.id === 'bt-search-input' ||
      e.target.parentNode.parentNode.id === 'bt-search-input'
    ) {
      // 검색의 타입을 선택
      const searchType = this.state.searchType;
      const searchValue = SEARCH_VALUE;

      const { ExamActions, paramData } = this.props;
      const filter = paramData.get('filter').toJS();

      if (searchValue !== filter[searchType]) {
        // 검색 타입 제거
        const searchOptions = [
          'searchAll',
          'infectionNo',
          'hostname',
          'ip',
          'targetName',
          'targetEmail',
          'examNo',
          'examName'
        ];
        searchOptions.map(option => delete filter[option]);

        if (searchValue !== '') {
          filter[searchType] = searchValue;
        }

        this.setState({ currentPage: 0 });
        ExamActions.changeInfectionPCListParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  // 개별 필터
  handleChangeFilter = (column, value, isMulti) => {
    const { ExamActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    // 멀티 선택 필터
    if (isMulti) {
      if (typeof filter[column] === 'undefined') {
        filter[column] = value;
      } else if (Number(filter[column]) === Number(value)) {
        delete filter[column];
      } else {
        if (Number(value) & Number(filter[column])) {
          filter[column] = Number(filter[column]) - Number(value);
        } else {
          filter[column] = Number(filter[column]) + Number(value);
        }
      }
      // 단일 선택 필터
    } else {
      if (filter[column] === value) {
        delete filter[column];
      } else {
        filter[column] = value;
      }
    }

    this.setState({ currentPage: 0 });
    ExamActions.changeInfectionPCListParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 날짜 필터
  handleChangeDateFilter = (type, data) => {
    const { ExamActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    if (data.startDate) {
      filter['start' + type] = data.startDate;
    }
    if (data.endDate) {
      filter['end' + type] = data.endDate;
    }

    this.setState({ currentPage: 0 });
    ExamActions.changeInfectionPCListParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 필터 초기화
  handleInitFilter = () => {
    this.setState({ searchType: 'searchAll', searchText: '' });

    const { ExamActions } = this.props;
    ExamActions.changeInfectionPCListParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }
  };

  // 페이지 이동 처리
  handlePagination = pageNo => {
    this.setState({ currentPage: pageNo });
  };

  // 페이지 개수 처리 (페이지 초기화)
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { loading, currentPage, pageSize, fitRowCount, searchType, searchText } = this.state;
    const { infectionPCList, totalPages, totalCount, paramData } = this.props;
    const { handleFetchData } = this;
    // 검색
    const {
      handleSearchOptions,
      handleChangeSearch,
      handleOnSearch,
      handleChangeFilter,
      handleChangeDateFilter,
      handleInitFilter,
      takeSearchValue,
      searchTextRef
    } = this;
    // 페이징
    const { handlePagination, handlePageSizeOnChange } = this;

    const filterData = paramData.get('filter').toJS();

    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = [];
    pageSizeArray.map(value => {
      pageSizeOptions.push({ text: value, value: value });
    });

    const searchOptions = [
      { key: 0, text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })), value: 'searchAll' },
      { key: 1, text: 'No', value: 'infectionNo' },
      { key: 2, text: 'PC', value: 'hostname' },
      { key: 3, text: 'IP', value: 'ip' },
      {
        key: 4,
        text: defineMessages(formatMessage({ id: 'ExamLeakPCList_1' })),
        value: 'targetName'
      },
      {
        key: 5,
        text: defineMessages(formatMessage({ id: 'ExamLeakPCList_2', defaultMessage: '대상자 메일' })),
        value: 'targetEmail'
      },
      {
        key: 6,
        text: defineMessages(formatMessage({ id: 'ExamLeakPCList_3', defaultMessage: '훈련 No' })),
        value: 'examNo'
      },
      {
        key: 7,
        text: defineMessages(formatMessage({ id: 'ExamLeakPCList_4', defaultMessage: '훈련명' })),
        value: 'examName'
      }
    ];

    return (
      <div className="exam-wrapper">
        <CtExamHeader />
        <div className="exam-leak-pc-area" ref={ref => (this.examPageRef = ref)}>
          <ExamLeakPCList
            manual
            data={infectionPCList.get('data').toJS()}
            totalCount={totalCount}
            page={currentPage}
            pages={totalPages}
            pageSize={pageSize}
            defaultPageSize={fitRowCount}
            pageSizeOptions={pageSizeOptions}
            loading={loading}
            onFetchData={handleFetchData}
            // 검색 영역
            searchObj={{
              filterData: filterData,
              currentPage: currentPage,
              pageSize: pageSize,
              totalCount: totalCount,
              searchType: searchType,
              searchText: searchText,
              searchOptions: searchOptions,
              handleSearchOptions: handleSearchOptions,
              handleChangeSearch: handleChangeSearch,
              handleOnSearch: handleOnSearch,
              handleInitFilter: handleInitFilter,
              defaultPageSize: fitRowCount,
              pageSizeOptions: pageSizeOptions,
              handlePageSizeOnChange: handlePageSizeOnChange,
              searchTextRef: searchTextRef,
              takeSearchValue: takeSearchValue
            }}
            // 필터
            handleChangeFilter={handleChangeFilter}
            handleChangeDateFilter={handleChangeDateFilter}
            // 페이징 처리
            handlePagination={handlePagination}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  // 감염 PC
  infectionPCList: state.exam.get('infectionPCList'),
  needReload: state.exam.get(['infectionPCList', 'needReload']),
  totalPages: state.exam.getIn(['infectionPCList', 'totalPages']),
  totalCount: state.exam.getIn(['infectionPCList', 'totalCount']),
  paramData: state.exam.getIn(['infectionPCList', 'param']),
  isAuth: state.exam.getIn(['infectionPCList', 'isAuth']),
  selectedExamSummaryNo: state.currentStatus.getIn(['examSummary', 'selected'])
});

const mapDispatchToProps = dispatch => ({
  ExamActions: bindActionCreators(examActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamLeakPC));



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtExamLeakPC.js